export default "__VITE_ASSET__C_q61B_r__"